module.exports = __webpack_public_path__ + "static/media/project_4.71c098e2.png";